var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Avatar as MuiAvatar, svgIconClasses } from '@mui/material';
import styled from '@mui/material/styles/styled';
import Box from '../Box';
import { MaleIcon, FemaleIIcon } from '../icons';
var defaultSizes = {
    small: 24,
    middle: 36,
    large: 48
};
var SexIcons = {
    // 男 icon
    1: MaleIcon,
    // 女 icon
    2: FemaleIIcon
};
export var RANDOM_COLOR = [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#1E88E5',
    '#0288D1',
    '#0097A7',
    '#009688',
    '#43A047',
    '#E65100',
    '#795548',
    '#757575',
];
var BoxRoot = styled(Box)({
    display: 'inline-block',
    borderRadius: '50%',
    position: 'relative',
});
var NewTipRoot = styled(Box)(function (_a) {
    var color = _a.color;
    return ({
        position: 'absolute',
        left: '-4px',
        width: '6px',
        height: '6px',
        display: 'inline-block',
        backgroundColor: color || '#4CAF50',
        borderRadius: '6px',
    });
});
var SexRoot = styled(Box)(function (_a) {
    var _b;
    var sex = _a.sex;
    var bgColor = {
        1: 'rgb(75, 132, 255)',
        2: 'rgb(255, 79, 123)'
    };
    return _b = {
            position: 'absolute',
            width: 12,
            height: 12,
            right: '-2px',
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            borderRadius: '50%',
            border: '1px solid #fff',
            background: bgColor[sex]
        },
        _b["." + svgIconClasses.root] = {
            color: '#fff',
            fontSize: 12,
            width: 'auto',
            height: 'auto',
        },
        _b;
});
var AvatarRoot = styled(MuiAvatar)(function (_a) {
    var size = _a.size, children = _a.children;
    return __assign({ width: defaultSizes[size] || size, height: defaultSizes[size] || size }, (children ? {
        // @ts-ignore
        backgroundColor: RANDOM_COLOR[((children === null || children === void 0 ? void 0 : children.charCodeAt(0)) || 0) % (RANDOM_COLOR === null || RANDOM_COLOR === void 0 ? void 0 : RANDOM_COLOR.length)],
        color: '#ffffff',
    } : {}));
});
var Avatar = function (_a) {
    var size = _a.size, disabled = _a.disabled, sex = _a.sex, showNewTip = _a.showNewTip, newTipColor = _a.newTipColor, otherProps = __rest(_a, ["size", "disabled", "sex", "showNewTip", "newTipColor"]);
    var SexIcon = SexIcons[sex];
    return (React.createElement(BoxRoot, { disabled: disabled, MaskProps: {
            sx: {
                borderRadius: '50%'
            }
        } },
        showNewTip && React.createElement(NewTipRoot, { color: newTipColor }),
        React.createElement(AvatarRoot, __assign({ size: size }, otherProps)),
        SexIcon ? (React.createElement(SexRoot, { sex: sex },
            React.createElement(SexIcon, null))) : null));
};
Avatar.defaultProps = {
    size: 'middle',
    disabled: false,
};
export default Avatar;
